import React, {useState} from 'react';
import Suvmanbalari from "./Suvmanbalari";
import Istemolchilar from "./Istemolchilar";
import Sanoatvatexnik from "./Sanoatvatexnik";
import Ekinmaydon from "./Ekinmaydon";
import Limit from "./Limit";
import {Button} from "antd";
import {PlusOutlined, RollbackOutlined} from "@ant-design/icons";
import {NavLink} from "react-router-dom";

const Xisobot = () => {
    const [component, setComponent] = useState(1)
    const project = () => {
        switch(component) {
            case 1: return <Suvmanbalari />;
            case 2: return <Istemolchilar />;
            case 3: return <Sanoatvatexnik />;
            case 4: return <Ekinmaydon />;
            case 5: return <Limit />;
            default: return <h1>No project match</h1>
        }
    }

    return (
        <div>
            <NavLink to="/sfr" className="btn btn-primary py-1 add-data">
                <RollbackOutlined /> Orqaga
            </NavLink>
            <h3 className="text-center text-uppercase mt-2 mb-4">Ma'lumot kiritish</h3>
            <div className="row">
                <div className="col-md-2">
                    <div className="row">
                        <div className="col-12 mb-1">
                            <button className="fw-bold text-uppercase btn btn-success w-100" onClick={() => setComponent(1)}>Suv manbalari</button>
                        </div>
                        <div className="col-12 mb-1">
                            <button className="fw-bold text-uppercase btn btn-success w-100" onClick={() => setComponent(2)}>Iste'molchilar</button>
                        </div>
                        <div className="col-12 mb-1">
                            <button className="fw-bold text-uppercase btn btn-success w-100" onClick={() => setComponent(3)}>Sanoat va texnik inshoatlar</button>
                        </div>
                        <div className="col-12 mb-1">
                            <button className="fw-bold text-uppercase btn btn-success w-100" onClick={() => setComponent(4)}>Ekin maydonlari </button>
                        </div>
                        <div className="col-12 mb-1">
                            <button className="fw-bold text-uppercase btn btn-success w-100" onClick={() => setComponent(5)}>Limit</button>
                        </div>
                    </div>
                </div>
                <div className="col-md-6">
                    { project() }
                </div>
            </div>
        </div>
    );
};

export default Xisobot;